module.exports = __webpack_public_path__ + "img/howell_6.8489102d.jpeg";